module.exports = __webpack_public_path__ + "img/content1-7.eeded855.webp";